// import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../../../../node_modules/custom-components/dist/custom-components.css';
import '../komodo/css/icons.css';
import '../komodo/css/fonts.css';
import '../komodo/atoms/shadows/css/shadows.css';
import '../komodo/atoms/information-badge/css/information-badge.css';
import '../komodo/atoms/warning-badge/css/warning-badge.css';
import '../komodo/atoms/danger-badge/css/danger-badge.css';
import '../komodo/atoms/success-badge/css/success-badge.css';

import '../komodo/fonts/n-a.eot';
import '../komodo/fonts/n-a.svg';
import '../komodo/fonts/n-a.ttf';
import '../komodo/fonts/n-a.woff';

import '../komodo/fonts/HelveticaNeueLTW01-35Thin.eot';
import '../komodo/fonts/HelveticaNeueLTW01-45Light.eot';
import '../komodo/fonts/HelveticaNeueLTW01-55Roman.eot';
import '../komodo/fonts/HelveticaNeueLTW01-56Italic.eot';
import '../komodo/fonts/HelveticaNeueLTW01-65Medium.eot';
import '../komodo/fonts/HelveticaNeueLTW01-75Bold.eot';
import '../komodo/fonts/HelveticaNeueLTW01-35Thin.svg';
import '../komodo/fonts/HelveticaNeueLTW01-45Light.svg';
import '../komodo/fonts/HelveticaNeueLTW01-55Roman.svg';
import '../komodo/fonts/HelveticaNeueLTW01-56Italic.svg';
import '../komodo/fonts/HelveticaNeueLTW01-65Medium.svg';
import '../komodo/fonts/HelveticaNeueLTW01-75Bold.svg';
import '../komodo/fonts/HelveticaNeueLTW01-35Thin.ttf';
import '../komodo/fonts/HelveticaNeueLTW01-45Light.ttf';
import '../komodo/fonts/HelveticaNeueLTW01-55Roman.ttf';
import '../komodo/fonts/HelveticaNeueLTW01-56Italic.ttf';
import '../komodo/fonts/HelveticaNeueLTW01-65Medium.ttf';
import '../komodo/fonts/HelveticaNeueLTW01-75Bold.ttf';
import '../komodo/fonts/HelveticaNeueLTW01-35Thin.woff';
import '../komodo/fonts/HelveticaNeueLTW01-45Light.woff';
import '../komodo/fonts/HelveticaNeueLTW01-55Roman.woff';
import '../komodo/fonts/HelveticaNeueLTW01-56Italic.woff';
import '../komodo/fonts/HelveticaNeueLTW01-65Medium.woff';
import '../komodo/fonts/HelveticaNeueLTW01-75Bold.woff';
import '../komodo/fonts/HelveticaNeueLTW01-35Thin.woff2';
import '../komodo/fonts/HelveticaNeueLTW01-45Light.woff2';
import '../komodo/fonts/HelveticaNeueLTW01-55Roman.woff2';
import '../komodo/fonts/HelveticaNeueLTW01-56Italic.woff2';
import '../komodo/fonts/HelveticaNeueLTW01-65Medium.woff2';
import '../komodo/fonts/HelveticaNeueLTW01-75Bold.woff2';

import './app.scss';
import '../components/browser/ie9.scss';
import '../components/browser/ie8.scss';

import '../../images/ie-inspect.png';
import '../../images/ie-select-edge.png';
import '../../images/oligo-label-sample.png';
import '../../images/icon-warning-small.png';
import '../../images/right-caret.png';
import '../../images/icon-warning-large.png';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/app/assets.ts